import { Card, Stack, Tooltip, Typography } from '@mui/material';

import { Button } from '@verantos-dev/shared-components';
import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import type { EmptyStateCardProps } from '../types';

export const EmptyStateCard = ({
  title,
  body,
  titleIcon,
  fill = false,
  action,
  'data-testid': dataTestId,
}: EmptyStateCardProps) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 0 0',
        alignSelf: 'stretch',
        minHeight: fill ? 0 : '348px',
        borderRadius: `${borderRadius.md}px`,
        gap: 4,
        textAlign: 'center',
      }}
      data-testid={dataTestId}
    >
      <Stack spacing={2} sx={{ alignItems: 'center', px: 28 }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          {titleIcon}
          <Typography variant="h5">{title}</Typography>
        </Stack>
        <Typography variant="body1" color="text.secondary">
          {body}
        </Typography>
      </Stack>
      {action && (
        <Tooltip title={action.tooltip ?? ''} disableHoverListener={!action.tooltip}>
          {/* span wrapper so the tooltip still shows on the disabled button */}
          <span>
            <Button
              id={action.dataTestId ?? 'empty-state-action'}
              displayLabel={action.label}
              variant="outlined"
              size="small"
              startIcon={action.startIcon}
              onClickHandler={action.onClick}
              disabled={action.disabled}
              sx={{ textTransform: 'none', px: 1.5, py: 4, fontSize: '14px' }}
            />
          </span>
        </Tooltip>
      )}
    </Card>
  );
};
